module.exports = "https://static.im-cdn.com/mjc/storefront/Sakra/static/media/EmptyStar.dca9f57c.svg";